export class QRect {
  constructor() {
    this.fLeft = 0;
    this.fTop = 0;
    this.fRight = 0;
    this.fBottom = 0;
    this.fValid = true;
  }

  InitRect(left, top, right, bottom) {
    this.fLeft = left;
    this.fTop = top;
    this.fRight = right;
    this.fBottom = bottom;
    this.fValid = true;
  }

  SetInfiniteRect() {
    this.fTop = Number.POSITIVE_INFINITY;
    this.fBottom = Number.NEGATIVE_INFINITY;
    this.fLeft = Number.POSITIVE_INFINITY;
    this.fRight = Number.NEGATIVE_INFINITY;
    this.fValid = false;
  }

  /**
   * @return {boolean}
   */
  IsValid() {
    return this.fValid;
  }

  UnionRect(theRect) {
    if (theRect.fLeft < this.fLeft) this.fLeft = theRect.fLeft;

    if (theRect.fTop < this.fTop) this.fTop = theRect.fTop;

    if (theRect.fRight > this.fRight) this.fRight = theRect.fRight;

    if (theRect.fBottom > this.fBottom) this.fBottom = theRect.fBottom;
  }

  ClipRect(theRect) {
    var r = this.Clone();

    if (r.fLeft < theRect.fLeft) r.fLeft = theRect.fLeft;

    if (r.fTop < theRect.fTop) r.fTop = theRect.fTop;

    if (r.fRight > theRect.fRight) r.fRight = theRect.fRight;

    if (r.fBottom > theRect.fBottom) r.fBottom = theRect.fBottom;

    if (r.left >= r.right || r.top <= r.bottom) {
      r.fValid = false;
    }

    return r;
  }

  MultiplyRect(mFactor) {
    var r = new QRect();
    r.fLeft = this.fLeft * mFactor;
    r.fTop = this.fTop * mFactor;
    r.fRight = this.fRight * mFactor;
    r.fBottom = this.fBottom * mFactor;
    return r;
  }

  FloorRect() {
    this.fLeft = Math.floor(this.fLeft);
    this.fTop = Math.floor(this.fTop);
    this.fRight = Math.floor(this.fRight);
    this.fBottom = Math.floor(this.fBottom);
  }

  Compare(aRect) {
    if (aRect.fLeft != this.fLeft) return false;
    if (aRect.fRight != this.fRight) return false;
    if (aRect.fTop != this.fTop) return false;
    if (aRect.fBottom != this.fBottom) return false;

    return true;
  }

  Clone() {
    var theC = new QRect();
    theC.fLeft = this.fLeft;
    theC.fRight = this.fRight;
    theC.fTop = this.fTop;
    theC.fBottom = this.fBottom;

    return theC;
  }

  Shift(deltaX, deltaY) {
    this.fLeft = this.fLeft + deltaX;
    this.fRight = this.fRight + deltaX;
    this.fTop = this.fTop + deltaY;
    this.fBottom = this.fBottom + deltaY;
  }

  Scale(scaleFactor) {
    this.fLeft = this.fLeft * scaleFactor;
    this.fRight = this.fRight * scaleFactor;
    this.fTop = this.fTop * scaleFactor;
    this.fBottom = this.fBottom * scaleFactor;
  }
}
